<template>
  <el-input-number v-model="childValue" :min="min" :max="max" :step="step" @change="handleChange" />
</template>

<script>
export default {
  name: "numberInput",
  props: {
    min: {
      Type: Number,
      Default: 0,
    },
    step: {
      Type: Number,
      Default: 1,
    },
    total:{
      Type:Number,
      Default:0,
      Require:false
    },
    numberValue:{
      Type:Number,
      Default:1,
      Require:true
    }
  },
  data(){
    return {
      childValue:this.numberValue,
      max:999999 // 库存限制已取消，设置一个很大的值
    }
  },
  computed:{

  },
  watch:{
    numberValue:{
      deep:true,
      immediate:true,
      handler(val){
        this.childValue = val
        this.$forceUpdate()
      }
    },
    min:{
      deep:true,
      immediate:true,
      handler(){
        this.$forceUpdate()
      }
    },
    step:{
      deep:true,
      immediate:true,
      handler(){
        this.$forceUpdate()
      }
    },
    total:{
      deep:true,
      immediate:true,
      handler(){
        // 库存限制已取消，不再根据total调整max
        this.$forceUpdate()
      }
    },
  },
  methods: {
    updateNumber(){
      this.$emit("updateNumber", this.childValue);
    },
    handleChange(val) {
      // 库存限制已取消，不再限制最大值
      if (val % this.step !== 0){
        //不符合规格时候增减，取大于当前值的最小倍数
        this.childValue = Math.ceil(val/this.step) * this.step
        this.max = this.$options.data().max
      }

      this.updateNumber()
      this.$forceUpdate()
    },
  },
};
</script>

<style scoped lang="scss">

</style>
